import { useState, useEffect } from "react";
import Footer from "../../../../components/Footer/Footer";
import Breadcrumbs from "../../../../components/Breadcrumbs/Breadcrumbs";
import useTrackOrder from "../hooks/useTrackOrder";
import TrackForm from "../components/TrackForm";
import TrackResult from "../components/TrackResult";
import tickicon from "../../../../assets/icons/tick-Icons.svg";
import "../styles/TrackOrderPage.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

export default function TrackOrderPage() {
  const [orderId, setOrderId] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const { orderData, loading, error, trackOrder, reset } = useTrackOrder();

  useEffect(() => {
    if (error) {
      setErrorMsg(error);
    }
  }, [error]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!orderId.trim()) {
      setErrorMsg("Please enter the Order ID / Tracking ID / AWB *");
      return;
    }
    setErrorMsg("");
    trackOrder(orderId);
    setOrderId("");
  };

  return (
    <>
      <Breadcrumbs paths={[{ label: "Track Shipments", to: "" }]} />

      <div className="track-container">
        {!orderData ? (
          <div className="track-box">
            <h2 className="track-title">
              Track By: Order ID / Tracking ID / AWB
            </h2>

            <TrackForm
              value={orderId}
              onChange={(e) => {
                setOrderId(e.target.value);
                setErrorMsg("");
              }}
              onSubmit={handleSubmit}
              loading={loading}
              errorMsg={errorMsg}
            />

            <div className="track-benefits">
              <h4>Key Benefits</h4>
              <ul>
                <li>
                  <LazyLoadImage effect="blur" src={tickicon} alt="Track in real time" /> Track in real time
                </li>
                <li>
                  <LazyLoadImage effect="blur" src={tickicon} alt="No login required" /> No login required
                </li>
              </ul>
            </div>
          </div>
        ) : (
          <TrackResult data={orderData} onBack={reset} />
        )}
      </div>
      <Footer />
    </>
  );
}
